/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
import { AnalyzeDocumentRequest as AnalyzeDocumentRequestMapper, BuildDocumentModelRequest as BuildDocumentModelRequestMapper, ComposeDocumentModelRequest as ComposeDocumentModelRequestMapper, AuthorizeCopyRequest as AuthorizeCopyRequestMapper, CopyAuthorization as CopyAuthorizationMapper } from "../models/mappers";
export var contentType = {
  parameterPath: "contentType",
  mapper: {
    serializedName: "Content-Type",
    required: true,
    type: {
      name: "Enum",
      allowedValues: ["application/octet-stream", "application/pdf", "application/vnd.openxmlformats-officedocument.presentationml.presentation", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "image/bmp", "image/heif", "image/jpeg", "image/png", "image/tiff"]
    }
  }
};
export var analyzeRequest = {
  parameterPath: ["options", "analyzeRequest"],
  mapper: {
    serializedName: "analyzeRequest",
    type: {
      name: "Stream"
    }
  }
};
export var accept = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "application/json",
    isConstant: true,
    serializedName: "Accept",
    type: {
      name: "String"
    }
  }
};
export var contentType1 = {
  parameterPath: "contentType",
  mapper: {
    defaultValue: "text/html",
    isConstant: true,
    serializedName: "Content-Type",
    type: {
      name: "String"
    }
  }
};
export var analyzeRequest1 = {
  parameterPath: ["options", "analyzeRequest"],
  mapper: {
    serializedName: "analyzeRequest",
    type: {
      name: "String"
    }
  }
};
export var accept1 = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "application/json",
    isConstant: true,
    serializedName: "Accept",
    type: {
      name: "String"
    }
  }
};
export var contentType2 = {
  parameterPath: "contentType",
  mapper: {
    defaultValue: "application/json",
    isConstant: true,
    serializedName: "Content-Type",
    type: {
      name: "String"
    }
  }
};
export var analyzeRequest2 = {
  parameterPath: ["options", "analyzeRequest"],
  mapper: AnalyzeDocumentRequestMapper
};
export var accept2 = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "application/json",
    isConstant: true,
    serializedName: "Accept",
    type: {
      name: "String"
    }
  }
};
export var endpoint = {
  parameterPath: "endpoint",
  mapper: {
    serializedName: "endpoint",
    required: true,
    type: {
      name: "String"
    }
  },
  skipEncoding: true
};
export var modelId = {
  parameterPath: "modelId",
  mapper: {
    constraints: {
      Pattern: new RegExp("[a-zA-Z0-9][a-zA-Z0-9._~-]{1,63}")
    },
    serializedName: "modelId",
    required: true,
    type: {
      name: "String"
    }
  }
};
export var pages = {
  parameterPath: ["options", "pages"],
  mapper: {
    constraints: {
      Pattern: new RegExp("^(\\d+(-\\d+)?)(,\\s*(\\d+(-\\d+)?))*$")
    },
    serializedName: "pages",
    type: {
      name: "String"
    }
  }
};
export var locale = {
  parameterPath: ["options", "locale"],
  mapper: {
    serializedName: "locale",
    type: {
      name: "String"
    }
  }
};
export var stringIndexType = {
  parameterPath: "stringIndexType",
  mapper: {
    serializedName: "stringIndexType",
    type: {
      name: "String"
    }
  }
};
export var apiVersion = {
  parameterPath: "apiVersion",
  mapper: {
    defaultValue: "2022-06-30-preview",
    isConstant: true,
    serializedName: "api-version",
    type: {
      name: "String"
    }
  }
};
export var resultId = {
  parameterPath: "resultId",
  mapper: {
    serializedName: "resultId",
    required: true,
    type: {
      name: "String"
    }
  }
};
export var contentType3 = {
  parameterPath: ["options", "contentType"],
  mapper: {
    defaultValue: "application/json",
    isConstant: true,
    serializedName: "Content-Type",
    type: {
      name: "String"
    }
  }
};
export var buildRequest = {
  parameterPath: "buildRequest",
  mapper: BuildDocumentModelRequestMapper
};
export var composeRequest = {
  parameterPath: "composeRequest",
  mapper: ComposeDocumentModelRequestMapper
};
export var authorizeCopyRequest = {
  parameterPath: "authorizeCopyRequest",
  mapper: AuthorizeCopyRequestMapper
};
export var copyToRequest = {
  parameterPath: "copyToRequest",
  mapper: CopyAuthorizationMapper
};
export var operationId = {
  parameterPath: "operationId",
  mapper: {
    serializedName: "operationId",
    required: true,
    type: {
      name: "String"
    }
  }
};
export var nextLink = {
  parameterPath: "nextLink",
  mapper: {
    serializedName: "nextLink",
    required: true,
    type: {
      name: "String"
    }
  },
  skipEncoding: true
};